
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      navIsBig: false,
      navHeight: 0,
    }
  },

  computed: {
    ...mapGetters('global', ['metaNavigation', 'socialMedia']),
  },

  mounted() {
    this.navHeight = this.$refs.navelbottom?.offsetHeight + 5
    window.addEventListener('resize', () => {
      this.navHeight = this.$refs.navelbottom?.offsetHeight + 5
    })

    window.addEventListener('scroll', () => {
      // Toggle sticky cart
      if (window.scrollY <= 56) {
        this.navIsBig = false
      } else {
        this.navIsBig = true
      }
    })
  },

  methods: {
    openFavorites() {
      this.$store.commit('favorites/setOpen')
    },
  },
}
